/**
 * Main Layout Component
 * 
 * Uses the same Header component as Builder/Designer for consistency.
 * Shares theme state via ThemeContext.
 */
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import Header from './Header';
import ErrorBoundary from './ErrorBoundary';
import './Layout.css';

export function Layout({ children, pageTitle }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { theme, setTheme } = useTheme();

    // Handle mode change - navigate to appropriate page
    const handleModeChange = (mode) => {
        if (mode === 'builder') {
            navigate('/dashboard');
        } else if (mode === 'agent-designer') {
            navigate('/designer');
        }
    };

    // Handle back to dashboard navigation
    const handleBackToDashboard = () => {
        navigate('/dashboard');
    };

    return (
        <div className="app-layout" data-theme={theme}>
            <Header
                activeMode="builder"
                onModeChange={handleModeChange}
                showLeftRibbon={false}
                showBackButton={true}
                onBackToDashboard={handleBackToDashboard}
                pageTitle={pageTitle}
                theme={theme}
                onThemeChange={setTheme}
                chatSidebarOpen={false}
                onToggleChatSidebar={() => {}}
            />
            <main className="app-main">
                <div className="app-content">
                    <ErrorBoundary name="Page" resetKey={location.pathname}>
                        {children}
                    </ErrorBoundary>
                </div>
            </main>
        </div>
    );
}

Layout.defaultProps = {
    pageTitle: undefined,
};

export default Layout;
